module.exports = __webpack_public_path__ + "static/media/waves.bb59c4ed.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/payment/Order/waves.svg
 ** module id = 476
 ** module chunks = 0
 **/